import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=7f988d94&scoped=true"
import script from "./alarm.vue?vue&type=script&lang=js"
export * from "./alarm.vue?vue&type=script&lang=js"
import style0 from "./alarm.vue?vue&type=style&index=0&id=7f988d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f988d94",
  null
  
)

export default component.exports